import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith("/dashboard")) {
      localStorage.removeItem("fp_token");
      if (!window.location.pathname.endsWith("/dashboard/login") && !window.location.pathname.endsWith("/dashboard/signup")) {
        window.location.href = "/dashboard/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

// Public
export const postContact = (data) => api.post("/contacts", data);
export const postBooking = (data) => api.post("/bookings", data);

// Auth
export const authSignup = (data) => api.post("/auth/signup", data);
export const authLogin = (data) => api.post("/auth/login", data);
export const authMe = () => api.get("/auth/me");

// Admin
export const adminStats = () => api.get("/admin/stats");
export const adminContacts = () => api.get("/admin/contacts");
export const adminPatchContact = (id, patch) => api.patch(`/admin/contacts/${id}`, patch);
export const adminDeleteContact = (id) => api.delete(`/admin/contacts/${id}`);
export const adminBookings = () => api.get("/admin/bookings");
export const adminPatchBooking = (id, patch) => api.patch(`/admin/bookings/${id}`, patch);
export const adminDeleteBooking = (id) => api.delete(`/admin/bookings/${id}`);
export const adminIntegrations = () => api.get("/admin/integrations");
